module.exports = __webpack_public_path__ + "img/bottom_cloudoutter.2b9aecd2.png";